import { render, staticRenderFns } from "./settingPermissions.vue?vue&type=template&id=44aa05c2"
import script from "./settingPermissions.vue?vue&type=script&lang=js"
export * from "./settingPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports